import React, { ReactElement } from "react";
import { useParams } from "react-router-dom";

import useLayout from "../../../hooks/use-layout";
import useUser from "../../../hooks/use-user";
import MainContainer from "../main-container";
import MainHeader from "../main-header";
import MainSidebar from "../main-sidebar";
import ViewContainer from "../view-container";

import Editor from "./editor";

export default function EditorPage(): ReactElement {
  const { id } = useParams();
  const { layout } = useLayout(id);
  const user = useUser();

  return (
    <MainContainer>
      {layout && (
        <MainSidebar
          layout={layout}
          workspaceId={layout.project?.workspace?.id}
        />
      )}
      <ViewContainer>
        <MainHeader />
        {layout && <Editor layout={layout} user={user.data?.me} />}
      </ViewContainer>
    </MainContainer>
  );
}
